// src/components/NotAuthorized.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';

const NotAuthorized: React.FC = () => {
    const navigate = useNavigate();
    const translate = useTranslate();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            p: 3
        }}>
            <BlockIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
            <Typography variant="h4" gutterBottom>
                {translate('resources.notAuthorized.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                {translate('resources.notAuthorized.description')}
            </Typography>
            <Button
                variant="contained"
                onClick={() => navigate('/')}
            >
                {translate('resources.notAuthorized.backHome')}
            </Button>
        </Box>
    );
};

export default NotAuthorized;